import { render, staticRenderFns } from "./AboutShowcase.vue?vue&type=template&id=2991406c&scoped=true"
import script from "./AboutShowcase.vue?vue&type=script&lang=js"
export * from "./AboutShowcase.vue?vue&type=script&lang=js"
import style0 from "./AboutShowcase.vue?vue&type=style&index=0&id=2991406c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991406c",
  null
  
)

export default component.exports